module.exports = __webpack_public_path__ + "static/media/hide.298a2415.svg";